
import type {Directive, } from "vue";
import type {VNode} from "@vue/runtime-core";
import {camelCaseToKebabCase} from "@/utilities/nonDomUtils";
import {isEmpty, set, uniqueId} from "lodash-es";

/**
 * Dyrektywa która obsługuje inputy w kontenerze
 * v-form-field="nazwa_zmiennej" - będzie przypisywać zmiany z inputa do zmiennej
 * Podczas kompilacji szablonów, zawartość atrybutu v-form-field jest tak naprawdę kopiowana do inputa jako atrybut v-model
 * Więc sama dyrektywa form-field nie musi się zajmować ustawianiem zmiennej i kopiowaniem zmian z inputa do zmiennej
 * Modyfikatory v-model takie jak .lazy, .trim i .number można też dodawać do v-form-field
 * v-form-field ustawi też klasę field-input-not-empty i field-input-empty odpowiednio dla niepustego i pustego inputa,
 * wszystkie te klasy będą ustawiane na elemencie który zawiera v-form-field
 */
export default {
    prepareInput: function (input: HTMLInputElement, node: VNode<any, Element>, el: Element) {
        if(!node.props) {
            node.props = {};
        }
        function setInputClasses() {
            if (node.props) {
                const input = node.props.input as HTMLInputElement;
                if (isEmpty(input.value)) {
                    el.classList.add('field-input-empty');
                    el.classList.remove('field-input-not-empty');
                } else {
                    el.classList.add('field-input-not-empty');
                    el.classList.remove('field-input-empty');
                }
                for(let validityKey in input.validity) {
                    // @ts-ignore
                    if(validityKey != 'valid' && input.validity[validityKey]) {
                        el.classList.add('field-input-'+camelCaseToKebabCase(validityKey));
                    } else {
                        el.classList.remove('field-input-'+camelCaseToKebabCase(validityKey));
                    }
                }
                if(!input.validity.valid){
                    el.classList.add('field-input-invalid');
                    el.classList.remove('field-input-valid');
                } else {
                    el.classList.remove('field-input-invalid');
                    el.classList.add('field-input-valid');
                }
            }
        }
        function onInputBlur(event: InputEvent) {
            if (node.props) {
                el.classList.add('field-input-touched');
                node.props.input.removeEventListener('blur', onInputBlur);
            }
        }
        switch (input.type) {
            case 'text':
            case 'email':
                setInputClasses();
                node.props.input.addEventListener('input', setInputClasses);
                node.props.input.addEventListener('blur', onInputBlur);
                break;
        }
    },
    prepareLabel: function (label: HTMLLabelElement, node: VNode<any, Element>) {
        if(node.props?.input) {
            if(!node.props.input.id.length) {
                node.props.input.id = uniqueId('input-');
            }
            // przypisanie id do labela
            label.htmlFor = node.props.input.id;
        }
    },
    mounted(el, binding, node) {
        if(!node.props) {
            node.props = {};
        }
        const input = el.querySelector('input');
        node.props.input = input;
        if(!node.props.input) {
            console.error('FormField: Nie znaleziono inputa', el);
        }
        const label = el.querySelector('label');
        node.props.label = label;
        if(label) {
            //@ts-ignore
            binding.dir.prepareLabel.apply(binding.dir,[label, node]);
        }
        if(input) {
            //@ts-ignore
            binding.dir.prepareInput.apply(binding.dir, [input, node, el]);
        }
    },
    updated(el, binding, node, prevVNode) {
        if(prevVNode.props) {
            const input = el.querySelector('input');
            if(input && (!prevVNode.props.input || (prevVNode.props.input && prevVNode.props.input != input))) {

                set(node,['props','input'], input);
                //@ts-ignore
                binding.dir.prepareInput.apply(binding.dir, [input, node, el]);
            }
            const label = el.querySelector('label');
            if(label && (!prevVNode.props.label || (prevVNode.props.label && prevVNode.props.label != label))) {
                set(node, ['props', 'label'], label);
                //@ts-ignore
                binding.dir.prepareLabel(label, node);
            }
        }
    },
    beforeUnmount( el, binding,node) {

    }
} as Directive<Element> ;